
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false)
        const isPersonalEnd = ref<boolean>(false)
        const isTeamStart = ref<boolean>(false)
        const isTeamEnd= ref<boolean>(false)
        const isStudentEnd = ref<boolean>(false)
        let domain = ''
        let origin = $route.query.origin || ''

        const getBtnState = () => {
            if ($store.state.activityData.templateConfig) {
                if ($store.state.activityData.templateConfig.individualEndTime) {
                    isPersonalEnd.value = new Date($store.state.activityData.serverTime).getTime() > new Date($store.state.activityData.templateConfig.individualEndTime).getTime()
                }
                const teamTime = $store.state.activityData.templateConfig.teamTime
                if (teamTime) {
                    isTeamStart.value = new Date($store.state.activityData.serverTime).getTime() > new Date(teamTime[0]).getTime()
                    isTeamEnd.value = new Date($store.state.activityData.serverTime).getTime() > new Date(teamTime[1]).getTime()
                }
                if ($store.state.activityData.templateConfig.aiTime) {
                    isStudentEnd.value = new Date($store.state.activityData.serverTime).getTime() > new Date($store.state.activityData.templateConfig.aiTime[1]).getTime()
                }
            }
        }

        const goPage = (type?: string) => {
            if (!isApp.value && type !== 'team') {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
                return
            }
            if (!$store.state.userInfo.token) {
                $store.commit('SET_DIALOGDATA', {
                    text: '请先登录~',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'login-btn'
                        }
                    ]
                })
                return
            }
            if (type === 'prize') {
                window.location.href = `${domain}/blindbox/#/record?id=${$store.state.aid}&origin=${origin}`
                return
            }
            if (!$store.state.userInfo.mobile && type !== 'team') {
                $store.commit('SET_DIALOGDATA', {
                    text: '请先绑定手机号~',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'bindmobile-btn'
                        }
                    ]
                })
                return
            }
            queryAnswer(type)
        }

        const queryAnswer = async (type?: string) => {
            COVER.pageLoading()
            let aid = $store.state.aid
            if (type === 'ai' || type === 'student' || type === 'team') {
                aid = $store.state.activityData.templateConfig.aiAid
            }
            const res = await _this.proxy.$request('/answer/user/count', {
                aid,
                isTeam: type === 'team' ? true : false,
                userinfo: $store.state.userInfo,
            }, 'post').catch(err => {
                COVER.pageLoaded()
                $store.commit('SET_DIALOGDATA', {
                    text: (err.errmsg || `(${ err.errmsg })`) ||  '网络错误~',
                    btns: [
                        {
                            text: '确定'
                        }
                    ]
                })
            })

            COVER.pageLoaded()

            const status = res.status

            if (status === 0) {   
                if (type === 'student') {
                    COVER.pageLoading()
                    
                    const data = await _this.proxy.$request('/apply/token', {
                        aid,
                        token: `${$store.state.userInfo.token || ''}`
                    }).catch((err) => {
                        COVER.pageLoaded()
                        $store.commit('SET_DIALOGDATA', {
                            text: err.errmsg ||  '网络错误~',
                            btns: [
                                {
                                    text: '确定'
                                }
                            ]
                        })
                    })

                    COVER.pageLoaded()
                    if (data._id) {
                        window.location.href = `${domain}/contestanswers/#/answer?id=${aid}&origin=${origin}`
                    } else {
                        $router.push('/apply')
                    }
                } else if (type === 'team') {
                    window.location.href = `${domain}/contestanswers/#/select?isTeam=1&id=${aid}&origin=${origin}`
                }else if (type === 'ai') {
                    window.location.href = `${domain}/contestanswers/#/aianswer?id=${aid}&origin=${origin}`
                } else if ($store.state.activityData.templateConfig.isOpenName || $store.state.activityData.templateConfig.isOpenPhone) {
                    window.location.href = `${domain}/contestanswers/#/select?id=${aid}&origin=${origin}`
                } else {
                    window.location.href = `${domain}/contestanswers/#/answer?id=${aid}&origin=${origin}`
                }
                return
            }

            let statusText = {
                '2010': '答题未开始',
                '2011': '答题已结束',
                '2012': '已超过答题总数',
                '2013': '亲，您今日答题次数已用完，明天再来答题吧。',
                '2014': '已完成答题',
                '2015': '当日已完成团队赛答题'
            }
            
            $store.commit('SET_DIALOGDATA', {
                text: statusText[status] ||  '网络错误~',
                btns: [
                    {
                        text: '确定',
                        className : 'cancel-btn'
                    }
                ]
            })
        }


        const goRank = () => {
            window.location.href = `${domain}/contestanswers/#/rank?id=${$store.state.aid}&origin=${origin}`
        }

        const goRule = () => {
            $router.push('/rule')
        }

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            nextTick(() => {
                COVER.getUser((res: any) => {
                    $store.commit('SET_USERINFO', res)
                })
            })

            COVER.track('load', $store.state.activityData.title)

            COVER.onshare($store.state.shareData)

            getBtnState()
            COVER.pageLoaded()

            domain = window.location.origin
        })    

        return {
            isPersonalEnd,
            isTeamStart,
            isTeamEnd,
            isStudentEnd,
            goPage,
            goRank,
            goRule
        }
    }
})
